import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom"; 
import "./ServiceSection.css";

const services = [
  {
    title: "Media Coverage & Outreach",
    img: "https://static.wixstatic.com/media/d56fdc_e6902495ddd945aebd6691c1cb93605b~mv2.png/v1/fill/w_1058,h_680,fp_0.65_0.37,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Orange%20and%20Brown%20Illustration%20Business%20Report%20Presentation%20(15).png",
    link: "#",
  },
   {
    title: "Influencer PR & BUZZ Creation",
    img: "https://static.wixstatic.com/media/d56fdc_b3a7025dc30145789f54e5384711e611~mv2.png/v1/crop/x_0,y_121,w_1200,h_772/fill/w_962,h_618,fp_0.50_0.50,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Web%20Developer%20Linkedin%20Post%20(4).png",
    link: "#",
  },
   {
    title: "Founder/Brand Persona Building",
    img: "https://static.wixstatic.com/media/d56fdc_e6902495ddd945aebd6691c1cb93605b~mv2.png/v1/fill/w_1058,h_680,fp_0.65_0.37,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Orange%20and%20Brown%20Illustration%20Business%20Report%20Presentation%20(15).png",
    link: "#",
  },
   {
    title: "Reputation Management",
    img: "https://static.wixstatic.com/media/d56fdc_e6902495ddd945aebd6691c1cb93605b~mv2.png/v1/fill/w_1058,h_680,fp_0.65_0.37,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Orange%20and%20Brown%20Illustration%20Business%20Report%20Presentation%20(15).png",
    link: "#",
  },
   {
    title: "Event PR & Coverage",
    img: "https://static.wixstatic.com/media/d56fdc_e6902495ddd945aebd6691c1cb93605b~mv2.png/v1/fill/w_1058,h_680,fp_0.65_0.37,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Orange%20and%20Brown%20Illustration%20Business%20Report%20Presentation%20(15).png",
    link: "#",
  },
   {
    title: "Digital PR",
    img: "https://static.wixstatic.com/media/d56fdc_e6902495ddd945aebd6691c1cb93605b~mv2.png/v1/fill/w_1058,h_680,fp_0.65_0.37,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Orange%20and%20Brown%20Illustration%20Business%20Report%20Presentation%20(15).png",
    link: "#",
  },
   {
    title: "Celebrity Endorsement PR (On Demand)",
    img: "https://static.wixstatic.com/media/d56fdc_e6902495ddd945aebd6691c1cb93605b~mv2.png/v1/fill/w_1058,h_680,fp_0.65_0.37,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Orange%20and%20Brown%20Illustration%20Business%20Report%20Presentation%20(15).png",
    link: "#",
  },
   {
    title: "Press Kit Development",
    img: "https://static.wixstatic.com/media/d56fdc_e6902495ddd945aebd6691c1cb93605b~mv2.png/v1/fill/w_1058,h_680,fp_0.65_0.37,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/Orange%20and%20Brown%20Illustration%20Business%20Report%20Presentation%20(15).png",
    link: "#",
  },
];

const headingVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const cardContainerVariants = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.4,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 50, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

export default function MarketingSolutions() {
  const navigate = useNavigate(); 

  return (
    <div className="marketing-solutions-section">
      <motion.h2
        className="marketing-solutions-heading"
        variants={headingVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
      >
        MARKETING SOLUTIONS
      </motion.h2>

      <motion.div
        className="marketing-solutions-cards-container"
        variants={cardContainerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        {services.map((service, index) => (
          <motion.div
            className="marketing-solutions-card"
            key={service.title}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
            <div className="marketing-solutions-content-left">
              <h3 className="marketing-solutions-title">{service.title}</h3>
              <motion.button
                onClick={() => navigate("/lets-connect")}
                className="marketing-solutions-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Know More
              </motion.button>
            </div>
            <div className="marketing-solutions-content-right">
              <motion.img
                src={service.img}
                alt={service.title}
                className="marketing-solutions-image"
                loading="lazy"
                draggable="false"
                whileHover={{ scale: 1.1, rotate: 5 }}
              />
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
